import React,{useState,useEffect} from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import HowToRegIcon from '@material-ui/icons/HowToReg';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';

import CircularProgress  from '@material-ui/core/CircularProgress'
import Backdrop from '@material-ui/core/Backdrop';

import MuiAlert from '@material-ui/lab/Alert';

import {useHistory } from "react-router-dom";

import { ValidatorForm, TextValidator} from 'react-material-ui-form-validator';

import {Link} from 'react-router-dom';
import Navbar from './Navbar'

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function Copyright() {
    return (
      <Typography variant="body2" color="textSecondary" align="center">
        {'Copyright © '}
        <Link color="inherit" to="mailto:jomonfullstack@gmail.com">
          Messenger@ developed by Jomon
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </Typography>
    );
  }
  
  const useStyles = makeStyles((theme) => ({
    paper: {
      marginTop: theme.spacing(12),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      border:'1px solid #3f51b5',
      padding:theme.spacing(4),
      width:'100%',
      borderRadius:'4px'
      
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: '#3f51b5',
    },
    form: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing(2),
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    },
    alert:{
      width: '100%',
      '& > * + *': {
        marginTop: theme.spacing(2),
      },
    },backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    }
  }));

  export function Signup () {
  
    const classes = useStyles();
    const [formValue, setValue] = useState({username:'',password:''});
    const [response,setStatus]  = useState({status:'',message:''})
     const [loading,setLoading]  = useState(false)
    const history = useHistory();
    const onHandleChange = 
    (e) => {
          var id  = e.target.id;
          var val = e.target.value;
          setValue({...formValue, [id]:val});
          //username:id=='username'?val:formValue.username,password:id=='password'?val:formValue['password'],confirmpassword:id=='confirmpassword'?val:formValue['confirmpassword']
        
        return true;
      }


      


      const customValidation = (e) =>{
            
            ValidatorForm.addValidationRule('minLength', (value) => {
            if(value.trim().length<5) {
            return false;
            }
            return true
            });
      }

    useEffect(() => {
      customValidation();
  },[]);
    const onHandleSubmit= (e)=>{
      setLoading(true);
      const data = new FormData(e.target);
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({"username":data.get('username'),"password":data.get('password'),"confirmpassword":data.get('password')})
    };
    fetch('https://mernsocketmessenger.herokuapp.com/user/signup', requestOptions)
        .then(response => {return response.json();})
        .then(data => {
          console.log(data);
          if(data.message=='Success'){
            //this.props.history.push('/chat')
            localStorage.setItem('token', data.token);
            localStorage.setItem('username', data.username);
            history.push("/chat");
          }
          setLoading(false)
          setStatus({message:data.message,status:data.status})
        }).catch(data=>{
          console.log('ssss');
          console.log(data);
        });
    }

    return (
      <Container component="main" maxWidth="xs">
        <Navbar/>
        <CssBaseline />
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <HowToRegIcon backgroundColor="#3f51b5" />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign Up
          </Typography>
          <div className={classes.alert}>
          <Alert style={{display:response.message.length>0?'flex':'none'}} severity={response.status!=200?"error":"success"}>{response.message}</Alert>
        </div>
          <ValidatorForm className={classes.form} onSubmit={onHandleSubmit } noValidate>
          <Backdrop className={classes.backdrop} open={loading} >
            <CircularProgress color="inherit" />
          </Backdrop>  
            <TextValidator
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="username"
              label="Username"
              name="username"
              autoComplete="username"
              autoFocus
              value={formValue['username']}
              onChange={onHandleChange}
              validators={['required','minLength']}
                    errorMessages={['this field is required', 'Please enter a valid username']}
            />
            <TextValidator
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="password"
            value={formValue['password']}
            onChange={onHandleChange}
            validators={['required','minLength']}
            errorMessages={['this field is required', 'password is not valid','Please enter a valid']}
          />
            
           
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
            >
              Sign Up
            </Button>
            <Grid container>
            <Grid item>
              <Link to="/" variant="body2">
                {"Have an account? Sign In"}
              </Link>
            </Grid>
          </Grid>
          </ValidatorForm>
        </div>
        <Box mt={8}>
          <Copyright />
        </Box>
      </Container>
    )
  }
